import { FixedFundReport } from '../../../types';
import { commonColProps, DataGridHandler } from '../../DataGridFlexSales';

export interface FixedFundReportDataGridContext {
  t: (key: string | string[]) => string;
  country: string;
}

const initialContext: FixedFundReportDataGridContext = {
  t: () => '',
  country: '',
};

export default (locale: Locale) => {
  const handler = new DataGridHandler<FixedFundReport, FixedFundReportDataGridContext>(
    initialContext,
    locale
  );

  handler.addColumn({
    accessor: 'country',
    type: 'string',
    title: ({ t }) => t('table.columns.country'),
    ...commonColProps.country,
  });

  handler.addColumn({
    accessor: 'store',
    type: 'string',
    title: ({ t, country }) => t([`table.columns.${country}.store`, 'table.columns.store']),
  });

  handler.addColumn({
    accessor: 'franchiseType',
    type: 'string',
    title: ({ t }) => t(['toolbar.labels.franchiseType']),
    width: { px: 100, pt: 100 },
  });

  handler.addColumn({
    accessor: 'month',
    type: 'date',
    title: ({ t }) => t('table.columns.month'),
    ...commonColProps.month,
  });

  handler.addColumn({
    accessor: 'tenderName',
    type: 'string',
    title: ({ t }) => t('table.columns.tender_name'),
  });

  handler.addColumn({
    accessor: 'type',
    type: 'string',
    title: ({ t }) => t('accounting-info-report.fixed-fund.columns.type'),
    width: {
      px: 100,
      pt: 50,
    },
  });

  handler.addColumn({
    accessor: 'account',
    type: 'string',
    title: ({ t }) => t('accounting-info-report.columns.account'),
    width: {
      px: 150,
      pt: 150,
    },
  });

  handler.addColumn({
    accessor: 'dr',
    type: 'number',
    title: ({ t }) => t('accounting-info-report.fixed-fund.columns.dr'),
    total: { type: 'sum' },
  });

  handler.addColumn({
    accessor: 'cr',
    type: 'number',
    title: ({ t }) => t('accounting-info-report.fixed-fund.columns.cr'),
    total: { type: 'sum' },
  });

  return handler;
};
